function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), React.createElement("path", {
    style: {
      "textIndent": 0,
      "textAlign": "start",
      "lineHeight": "normal",
      "textTransform": "none",
      "blockProgression": "tb",
      "InkscapeFontSpecification": "Sans"
    },
    d: "M 16 4 C 9.3844277 4 4 9.3844277 4 16 C 4 22.615572 9.3844277 28 16 28 C 22.615572 28 28 22.615572 28 16 C 28 9.3844277 22.615572 4 16 4 z M 16 6 C 21.534692 6 26 10.465308 26 16 C 26 21.534692 21.534692 26 16 26 C 10.465308 26 6 21.534692 6 16 C 6 10.465308 10.465308 6 16 6 z M 11.5 12 C 10.671573 12 10 12.671573 10 13.5 C 10 14.328427 10.671573 15 11.5 15 C 12.328427 15 13 14.328427 13 13.5 C 13 12.671573 12.328427 12 11.5 12 z M 20.5 12 C 19.671573 12 19 12.671573 19 13.5 C 19 14.328427 19.671573 15 20.5 15 C 21.328427 15 22 14.328427 22 13.5 C 22 12.671573 21.328427 12 20.5 12 z M 16 18 C 13.332659 18 10.979561 19.335501 9.53125 21.34375 L 11.15625 22.5 C 12.247939 20.986249 13.991341 20 16 20 C 18.008659 20 19.752061 20.986249 20.84375 22.5 L 22.46875 21.34375 C 21.020439 19.335501 18.667341 18 16 18 z",
    color: "#000",
    overflow: "visible",
    fontFamily: "Sans"
  }));
};

export default __webpack_public_path__ + "static/media/sad.892d22fc.svg";
export { SvgComponent as ReactComponent };